import { render, staticRenderFns } from "./PopupGovernmentAdd.vue?vue&type=template&id=2b7531ec"
import script from "./PopupGovernmentAdd.vue?vue&type=script&lang=js"
export * from "./PopupGovernmentAdd.vue?vue&type=script&lang=js"
import style0 from "./PopupGovernmentAdd.vue?vue&type=style&index=0&id=2b7531ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports